import { triniumApi } from '@api/Trinium/slice';
import { FetchJobCategoriesRequest, JobCategory, ServiceCharge } from './types';
import { BaseApiRequest } from '@api/Trinium/types';

const jobCategoriesSlice = triniumApi.injectEndpoints({
	endpoints(builder) {
		return {
			fetchServices: builder.query<ServiceCharge[], FetchJobCategoriesRequest>({
				query: ({ terminalNumber, categoryId }) => ({
					url: `/${terminalNumber}/jobcategories/${categoryId}/services`
				})
			}),

			fetchCategories: builder.query<JobCategory[], BaseApiRequest>({
				query: ({ terminalNumber }) => ({
					url: `/${terminalNumber}/jobcategories`
				}),
				/** Reference data that does not change within a session; the default 60s would refetch it on nearly every modal open */
				keepUnusedDataFor: Number.MAX_VALUE
			})
		};
	}
});

export const { useFetchServicesQuery, useFetchCategoriesQuery } = jobCategoriesSlice;
